import { FC, PropsWithChildren } from 'react'
import { TensorFlowProvider } from './TensorflowProvider'

export const Providers: FC<PropsWithChildren> = ({ children }) => {
  return <TensorFlowProvider>{children}</TensorFlowProvider>
}
